import type { ToolMenuItem } from '@/types';
import type { Disposable, Model } from '@patsnap/tahiti-core';

export const ToolsService = Symbol('ToolsService');

export interface ToolsService extends Model<ToolMenuItem[]> {
    /**
     * 注册工具
     * @param toolMenuItem 工具
     */
    registerToolMenuItem: (toolMenuItem: ToolMenuItem) => Disposable;
    /**
     * 获取工具，按注册时配置的顺序（order）返回
     */
    getToolMenuItems: () => ToolMenuItem[];
}
